import { render, staticRenderFns } from "./image-grid.vue?vue&type=template&id=61ffaf9d&scoped=true"
import script from "./image-grid.vue?vue&type=script&lang=js"
export * from "./image-grid.vue?vue&type=script&lang=js"
import style0 from "./image-grid.vue?vue&type=style&index=0&id=61ffaf9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffaf9d",
  null
  
)

export default component.exports